
































































import Vue, { PropType } from "vue";
import { KaiwaCard } from "@/models/KaiwaCard";

export default Vue.extend({
  name: "KaiwaCardItem",
  components: {},
  props: {
    card: {
      type: Object as PropType<KaiwaCard>,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    tab: null,
    labels: [
      {
        key: "hp",
        label: "HP",
      },
      {
        key: "atk",
        label: "攻撃力",
      },
      {
        key: "def",
        label: "防御力",
      },
      {
        key: "agi",
        label: "素早さ",
      },
      {
        key: "dex",
        label: "器用さ",
      },
      {
        key: "int",
        label: "知力",
      },
    ],
  }),
  computed: {
    rgbValue(): any {
      if (!this.card) {
        return { r: 0, g: 0, b: 0 };
      }

      const hexValue = (this.card as any).design.backgroundColor
        .replace("#", "")
        .split("");
      let r, g, b;
      if (hexValue.length === 3) {
        r = parseInt(hexValue[0].toString() + hexValue[0].toString(), 16);
        g = parseInt(hexValue[1].toString() + hexValue[1].toString(), 16);
        b = parseInt(hexValue[2].toString() + hexValue[2].toString(), 16);
      } else {
        r = parseInt(hexValue[0].toString() + hexValue[1].toString(), 16);
        g = parseInt(hexValue[2].toString() + hexValue[3].toString(), 16);
        b = parseInt(hexValue[4].toString() + hexValue[5].toString(), 16);
      }
      return { r, g, b };
    },
    shouldDark() {
      if (!this.card) {
        return false;
      }

      const gamma = 2.2;
      const l =
        0.2126 * Math.pow((this as any).rgbValue.r / 255, gamma) +
        0.7152 * Math.pow((this as any).rgbValue.g / 255, gamma) +
        0.0722 * Math.pow((this as any).rgbValue.b / 255, gamma);

      return l <= 0.5;
    },
  },
});
